export const courseHint = [
  {
    icon: 'monitor',
    iconColor: 'green',
    text: 'Доступна презентація',
  },
  {
    icon: 'book',
    iconColor: 'green',
    text: 'Домашнє завдання виконано',
  },
  {
    icon: 'book',
    iconColor: 'yellow',
    text: 'Домашнє завдання не виконано повністю.',
  },
  {
    icon: 'book',
    iconColor: 'red',
    text: 'Протерміноване домашнє завдання',
  },
  {
    icon: 'list',
    iconColor: 'green',
    text: 'Вордліст (словник у PDF)',
  },
  {
    icon: 'headphones',
    iconColor: 'green',
    text: 'Слова з озвучкою',
  },
  {
    icon: 'youtube',
    iconColor: 'green',
    text: 'Доступне посилання на відео бонусного заняття',
  },
  {
    icon: 'pdf',
    iconColor: 'green',
    text: 'Скачати презентацію в PDF',
  }
];

export const homeworkHint = [
  {
    lineColor: 'green',
    text: 'Зелена смужка (пройдений тест)',
  },
  {
    lineColor: 'yellow',
    text: 'Жовта смужка (незакінчений тест)',
  },
  {
    lineColor: 'gray',
    text: 'Сіра смужка (нерозпочатий тест)',
  },
];

export const attemptsHint = [
  {
    lineColor: 'green',
    text: 'Правильна відповідь',
  },
  {
    lineColor: 'red',
    text: 'Неправильна відповідь',
  },
  {
    lineColor: 'gray',
    text: 'Без відповіді',
  },
];